import { Card, CardContent } from '@/components/ui/card';
import { ShieldCheck, Banknote, AlertTriangle, FileText } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { IEmployeeStatCardsProps } from '@/@types/employee-detail';

export function EmployeeStatCards({
  activePolicies,
  totalPremiumPerYear,
  expiringSoon,
  docsUploaded,
  docsTotal,
}: IEmployeeStatCardsProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <Card>
        <CardContent className="flex items-center gap-3 p-4">
          <div className="rounded-lg bg-primary/10 p-2">
            <ShieldCheck className="h-5 w-5 text-primary" aria-hidden="true" />
          </div>
          <div>
            <p className="text-2xl font-semibold text-foreground">{activePolicies}</p>
            <p className="text-xs text-muted-foreground">Active Policies</p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="flex items-center gap-3 p-4">
          <div className="rounded-lg bg-primary/10 p-2">
            <Banknote className="h-5 w-5 text-primary" aria-hidden="true" />
          </div>
          <div>
            <p className="text-2xl font-semibold text-foreground">{totalPremiumPerYear}</p>
            <p className="text-xs text-muted-foreground">Total Premium/yr</p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="flex items-center gap-3 p-4">
          <div className={cn('rounded-lg p-2', expiringSoon > 0 ? 'bg-orange-500/10' : 'bg-primary/10')}>
            <AlertTriangle
              className={cn('h-5 w-5', expiringSoon > 0 ? 'text-orange-500' : 'text-primary')}
              aria-hidden="true"
            />
          </div>
          <div>
            <p className="text-2xl font-semibold text-foreground">{expiringSoon}</p>
            <p className="text-xs text-muted-foreground">Expiring Soon</p>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="flex items-center gap-3 p-4">
          <div className="rounded-lg bg-primary/10 p-2">
            <FileText className="h-5 w-5 text-primary" aria-hidden="true" />
          </div>
          <div>
            <p className="text-2xl font-semibold text-foreground">
              {docsUploaded}/{docsTotal}
            </p>
            <p className="text-xs text-muted-foreground">Documents</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
